// "Remember me" uit = alleen ingelogd zolang de browser open is.
// De login staat (zoals altijd) in localStorage; daarnaast:
//   localStorage  "session_only" = "1"  -> deze login mag de browser niet overleven
//   sessionStorage "session_alive" = "1" -> deze tab hoort bij de lopende sessie
// sessionStorage verdwijnt als de browser sluit. Een nieuwe tab heeft hem ook
// niet, dus die vraagt eerst via een BroadcastChannel of er nog een andere
// Cadmus-tab open is; zo niet, dan was de browser dicht -> uitloggen.
import { clearSession } from "./session";

const SESSION_ONLY_KEY = "session_only";
const ALIVE_KEY = "session_alive";
const CHANNEL = "cadmus-session";
// Ruim genoeg voor een andere tab die even bezig is (scan, PDF)
const PING_TIMEOUT_MS = 1000;

const ls = {
  get: (k) => { try { return localStorage.getItem(k); } catch { return null; } },
  set: (k, v) => { try { localStorage.setItem(k, v); } catch { /* geen opslag */ } },
  del: (k) => { try { localStorage.removeItem(k); } catch { /* geen opslag */ } },
};
const ss = {
  get: (k) => { try { return sessionStorage.getItem(k); } catch { return null; } },
  set: (k, v) => { try { sessionStorage.setItem(k, v); } catch { /* geen opslag */ } },
};

let channel = null;
const getChannel = () => {
  if (!channel && typeof BroadcastChannel !== "undefined") {
    channel = new BroadcastChannel(CHANNEL);
    // Andere tabs die vragen of de sessie nog leeft een antwoord geven
    channel.addEventListener("message", (e) => {
      if (e.data === "ping" && ss.get(ALIVE_KEY)) channel.postMessage("pong");
    });
  }
  return channel;
};

// Na een geslaagde login aanroepen
export function markLogin(remember) {
  if (remember) {
    ls.del(SESSION_ONLY_KEY);
  } else {
    ls.set(SESSION_ONLY_KEY, "1");
    ss.set(ALIVE_KEY, "1");
    getChannel();
  }
}

// Bij het opstarten van de app, vóór het renderen. Resolvet altijd.
export function checkSessionOnly() {
  getChannel();
  // Normale login (of Remember me aan), of geen login: niks te doen
  if (!ls.get("token") || ls.get(SESSION_ONLY_KEY) !== "1") return Promise.resolve();
  // Deze tab hoorde al bij de sessie (bv. herladen)
  if (ss.get(ALIVE_KEY)) return Promise.resolve();

  const ch = getChannel();
  if (!ch) {
    // Geen BroadcastChannel (heel oude browser): veilig kant = uitloggen
    clearSession();
    ls.del(SESSION_ONLY_KEY);
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    let done = false;
    const onMsg = (e) => {
      if (e.data !== "pong" || done) return;
      done = true;
      ch.removeEventListener("message", onMsg);
      ss.set(ALIVE_KEY, "1"); // nog een Cadmus-tab open: zelfde sessie
      resolve();
    };
    ch.addEventListener("message", onMsg);
    ch.postMessage("ping");
    setTimeout(() => {
      if (done) return;
      done = true;
      ch.removeEventListener("message", onMsg);
      clearSession(); // browser was dicht: niet ingelogd blijven
      ls.del(SESSION_ONLY_KEY);
      resolve();
    }, PING_TIMEOUT_MS);
  });
}
